import { createAction, props } from '@ngrx/store';

export const getTaskData = createAction(
    '[get Task]',
    props<{idService: number}>()
);

export const getTaskDataSuccess = createAction(
    '[get Task] success',
    props<{observation: string}>()
);

export const getServiceData = createAction(
    '[getService]',
    props<{idService: number}>()
);

export const getServiceDataSuccess = createAction(
    '[get Service] success',
    props<{description: string}>()
);
